import { render, staticRenderFns } from "./NewCustomDocument.vue?vue&type=template&id=41364536&"
import script from "./NewCustomDocument.vue?vue&type=script&lang=js&"
export * from "./NewCustomDocument.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('41364536')) {
      api.createRecord('41364536', component.options)
    } else {
      api.reload('41364536', component.options)
    }
    module.hot.accept("./NewCustomDocument.vue?vue&type=template&id=41364536&", function () {
      api.rerender('41364536', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/global/documentManagement/vistas/modals/NewCustomDocument.vue"
export default component.exports